// extracted by mini-css-extract-plugin
export default {"multiSelectCrumbs":"E3-z"};